import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Generated class for the ReservasValorLiquidarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'reservas-valor-liquidar',
  templateUrl: 'reservas-valor-liquidar.html'
})
export class ReservasValorLiquidarComponent {

  @Input() listaTurno = []
  @Output() actualizarValores = new EventEmitter<string>();
  constructor() {
  }

  actualizarValor(item: any, i: any) {
    this.actualizarValores.emit(item)
  }

}



// WEBPACK FOOTER //
// ./src/components/reservas-valor-liquidar/reservas-valor-liquidar.ts